var _____WB$wombat$assign$function_____ = function (name) {
  return (
    (self._wb_wombat &&
      self._wb_wombat.local_init &&
      self._wb_wombat.local_init(name)) ||
    self[name]
  );
};
if (!self.__WB_pmw) {
  self.__WB_pmw = function (obj) {
    this.__WB_source = obj;
    return this;
  };
}
{
  let window = _____WB$wombat$assign$function_____("window");
  let self = _____WB$wombat$assign$function_____("self");
  let document = _____WB$wombat$assign$function_____("document");
  let location = _____WB$wombat$assign$function_____("location");
  let top = _____WB$wombat$assign$function_____("top");
  let parent = _____WB$wombat$assign$function_____("parent");
  let frames = _____WB$wombat$assign$function_____("frames");
  let opener = _____WB$wombat$assign$function_____("opener");

  var pimcore = pimcore || {};
  pimcore["location"] = {
    ip: "207.241.231.171",
    latitude: 37.751,
    longitude: -97.822,
    country: {
      code: "US",
      name: "United States",
      names: {
        de: "USA",
        en: "United States",
        es: "Estados Unidos",
        fr: "\u00c9tats-Unis",
        ja: "\u30a2\u30e1\u30ea\u30ab\u5408\u8846\u56fd",
        "pt-BR": "Estados Unidos",
        ru: "\u0421\u0428\u0410",
        "zh-CN": "\u7f8e\u56fd",
      },
      subDivision: "",
    },
    address: {
      postalCode: "",
      city: "",
    },
  };
}
/*
     FILE ARCHIVED ON 05:25:25 Dec 28, 2018 AND RETRIEVED FROM THE
     INTERNET ARCHIVE ON 21:36:36 Jul 07, 2022.
     JAVASCRIPT APPENDED BY WAYBACK MACHINE, COPYRIGHT INTERNET ARCHIVE.

     ALL OTHER CONTENT MAY ALSO BE PROTECTED BY COPYRIGHT (17 U.S.C.
     SECTION 108(a)(3)).
*/
/*
playback timings (ms):
  captures_list: 125.529
  exclusion.robots: 0.189
  exclusion.robots.policy: 0.174
  cdx.remote: 0.11
  esindex: 0.013
  LoadShardBlock: 87.459 (3)
  PetaboxLoader3.datanode: 96.565 (4)
  CDXLines.iter: 19.842 (3)
  load_resource: 42.806
  PetaboxLoader3.resolve: 29.998
*/
